import { sendRequest } from "@infrastructure/api/api";
import ApiResponse from "@core/types/apiResponse";
import { FinanceConfigSaveResponse } from "@features/admin/finance/types/deductibleConfig";
import {
    FinanceCategoryResponse,
    FinanceCategoryCalcTypeOption,
} from "@features/admin/finance/category/types/financeCategory";
import {
    CreateFinanceCategoryRequest,
    UpdateFinanceCategoryRequest,
} from "@features/admin/finance/category/types/financeCategoryRequests";

const toQueryParams = (params: Record<string, any>): Record<string, string> => {
    const result: Record<string, string> = {};
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;
        result[key] = typeof value === "boolean" ? (value ? "1" : "0") : String(value);
    }
    return result;
};

export const fetchFinanceCategoryCalcTypes = async (
    nationId: number
): Promise<ApiResponse<FinanceCategoryCalcTypeOption[]>> => {
    return sendRequest<never, FinanceCategoryCalcTypeOption[]>(
        "GET",
        `nation/${nationId}/finance/category/calctype/query`
    );
};

export const fetchFinanceCategories = async (
    nationId: number,
    params: any
): Promise<ApiResponse<FinanceCategoryResponse>> => {
    return sendRequest<never, FinanceCategoryResponse>(
        "GET",
        `nation/${nationId}/finance/category/query?${new URLSearchParams(toQueryParams(params))}`
    );
};

export const createFinanceCategory = async (
    nationId: number,
    data: CreateFinanceCategoryRequest
): Promise<ApiResponse<FinanceConfigSaveResponse>> => {
    return sendRequest<CreateFinanceCategoryRequest, FinanceConfigSaveResponse>(
        "POST",
        `nation/${nationId}/finance/category/create`,
        data
    );
};

export const updateFinanceCategory = async (
    nationId: number,
    categoryGroupId: number,
    data: UpdateFinanceCategoryRequest
): Promise<ApiResponse<FinanceConfigSaveResponse>> => {
    return sendRequest<UpdateFinanceCategoryRequest, FinanceConfigSaveResponse>(
        "POST",
        `nation/${nationId}/finance/category/${categoryGroupId}/update`,
        data
    );
};

export const disableFinanceCategory = async (
    nationId: number,
    categoryGroupId: number
): Promise<ApiResponse<FinanceConfigSaveResponse>> => {
    return sendRequest<never, FinanceConfigSaveResponse>(
        "POST",
        `nation/${nationId}/finance/category/${categoryGroupId}/disable`
    );
};

export const enableFinanceCategory = async (
    nationId: number,
    categoryGroupId: number
): Promise<ApiResponse<FinanceConfigSaveResponse>> => {
    return sendRequest<never, FinanceConfigSaveResponse>(
        "POST",
        `nation/${nationId}/finance/category/${categoryGroupId}/enable`
    );
};
